import {useTranslation} from 'react-i18next';
import React from 'react';
import theme from '@/style';
import {toPriceStr} from '@/utils';
const rightIcon = require('@components/assets/icons/me-list-item/right-icon.webp');

export interface ScratchResultProps {
  orderList: {
    cardId: string;
    status: number;
    winAmount: number;
  }[];
}

const ScratchResult = ({orderList = []}: ScratchResultProps) => {
  const {i18n} = useTranslation();

  return (
    <div className="mt-3 bg-[#F8F9FF] p-3">
      <div>
        <div className="text-center font-medium text-[#9FA5AC]">
          {i18n.t('game-page.label.myBets')}
        </div>
      </div>
      <div className="my-3 h-px bg-[#D8E0EA]" />
      <div>
        {orderList.slice(0, 4).map((item, _i) => {
          return (
            <div key={_i} className="flex items-center justify-between gap-4">
              <span className="font-bold text-[#9FA5AC]">
                {i18n.t('label.id')}:{item.cardId.toUpperCase()}
              </span>

              {item.status === 2 ? (
                <span
                  className="text-sm font-bold"
                  style={{color: theme.basicColor.dark}}>
                  {i18n.t('game-page.label.unused')}
                </span>
              ) : (
                <div className="flex items-center gap-1">
                  <span className="font-medium">{i18n.t('label.won')}</span>
                  <span className="font-din text-sm font-bold">
                    {toPriceStr(item.winAmount)}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {orderList.length > 4 && (
        <div className="mt-3 flex h-12 items-center justify-between">
          <span className="font-medium">View All</span>
          <img src={rightIcon} alt="" className="h-3.5 w-3.5" />
        </div>
      )}
    </div>
  );
};

export default ScratchResult;
